(function () {
  'use strict';

  const sections = document.querySelectorAll('.ol-collection');
  if (!sections.length) return;

  sections.forEach(function (section) {
    const grid = section.querySelector('[data-ol-collection-grid]');
    const prevBtn = section.querySelector('[data-ol-collection-prev]');
    const nextBtn = section.querySelector('[data-ol-collection-next]');
    const progressBar = section.querySelector('.ol-collection__progress-bar');

    if (!grid) return;

    function scrollByCard(direction) {
      const card = grid.querySelector('.ol-collection__card');
      if (!card) return;
      const cardWidth = card.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(grid).gap) || 16;
      grid.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    }

    function updateProgress() {
      if (!progressBar) return;
      const scrollMax = grid.scrollWidth - grid.clientWidth;
      // Largeur du thumb = proportion visible du carrousel.
      const thumbWidth = Math.min(1, grid.clientWidth / grid.scrollWidth) * 100;
      progressBar.style.width = thumbWidth + '%';
      if (scrollMax <= 0) {
        progressBar.style.left = '0%';
        return;
      }
      // Position du thumb = ratio de scroll sur la course restante (100% - thumb).
      const ratio = grid.scrollLeft / scrollMax;
      progressBar.style.left = ratio * (100 - thumbWidth) + '%';
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      const scrollMax = grid.scrollWidth - grid.clientWidth - 1;
      prevBtn.disabled = grid.scrollLeft <= 0;
      nextBtn.disabled = grid.scrollLeft >= scrollMax;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    grid.addEventListener('scroll', function () {
      updateProgress();
      updateNavState();
    }, { passive: true });

    updateProgress();
    updateNavState();
  });
})();
